const STYLES = {
  Returned: "bg-orange-100 text-orange-700 border-orange-200",
  Refunded: "bg-red-100 text-red-700 border-red-200",
  Cancelled: "bg-rose-100 text-rose-700 border-rose-200",
};

export const OutcomeBadges = ({ outcome, skip = [], testId }) => {
  const kinds = (outcome?.kinds || []).filter((k) => !skip.includes(k));
  if (!kinds.length) return null;
  const tip = (outcome?.events || []).map((e) => e.label).join("\n");
  return (
    <div className="mt-1 flex flex-wrap gap-1" data-testid={testId}>
      {kinds.map((k) => (
        <span key={k} title={tip}
              className={`inline-flex items-center text-[10px] uppercase tracking-wider border rounded px-1.5 py-0.5 font-semibold ${STYLES[k] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
          {k}
        </span>
      ))}
    </div>
  );
};
